module.exports = __webpack_public_path__ + "static/media/premier.7560f8a9.jpg";